import { Accordion, StyledFlex } from '@dreryk/react-components';

import { patientPortalTranslationKeys } from '../../translations';
import { StyledAccordionSectionContent } from '../HealthcareProviderPatientPortalPanel.styled';
import { TextViewWithClipboard } from '../TextViewWithClipboard';
import { WidgetInfoSection } from '../healthcarePoviderPatientPortalWidgetInfo/WidgetInfoSection';

const t = patientPortalTranslationKeys;

type DataForPatientsSectionProps = Readonly<{
   id: string;
   healthcareProviderCode: string;
   patientPortalUrl: string;
}>;

export const DataForPatientsSection = (props: DataForPatientsSectionProps): JSX.Element => {
   return (
      <Accordion.Section id={props.id} testId={props.id} label={t.dataForPatients}>
         <StyledAccordionSectionContent>
            <StyledFlex gap={'8px'}>
               <StyledFlex direction={'column'} gap={'24px'} flex={'28%'}>
                  <TextViewWithClipboard
                     label={t.healthcareProviderCode}
                     testId={'healthcareProviderCode'}
                     value={props.healthcareProviderCode}
                  />
                  <TextViewWithClipboard
                     label={t.patientPortalLinkWithCode}
                     testId={'patientPortalLinkWithCode'}
                     value={props.patientPortalUrl}
                  />
               </StyledFlex>
               <WidgetInfoSection />
            </StyledFlex>
         </StyledAccordionSectionContent>
      </Accordion.Section>
   );
};
